import { MIN_GIG_PRICE_RANGE, MAX_GIG_PRICE_RANGE } from '../../consts';

export const CUSTOM_BUDGET_VALUE = 'custom';

export const RANGE_KEYS = {
    MIN: 'min',
    MAX: 'max',
};

export const DOMAttributes = {
    [RANGE_KEYS.MIN]: MIN_GIG_PRICE_RANGE,
    [RANGE_KEYS.MAX]: MAX_GIG_PRICE_RANGE,
};

export const MIN_GIG_PRICE = 5;
